import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'ts-radio-button',
  standalone: true,
  imports: [MatRadioModule],
  template: `
    <mat-radio-button [value]="value" [disabled]="disabled" [disableRipple]="disableRipple" [tabIndex]="tabIndex">
      <ng-content />
    </mat-radio-button>
  `,
  host: { class: 'ts-radio-button' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TsRadioButtonComponent {
  @Input({ required: true }) value: unknown;
  @Input() disabled = false;
  @Input() disableRipple = false;
  @Input() tabIndex = 0;
}
